import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-user',
  standalone: true,
  templateUrl: './help-user.component.html',
  styleUrls: ['./help-user.component.css'],
})
export class HelpUserComponent {
  readonly parent = input.required<HelpComponent>();
}
